// extracted by mini-css-extract-plugin
export var actions = "_6-4";
export var brand = "_6-3";
export var header = "_6-0";
export var headerContent = "_6-1";
export var identity = "_6-5";
export var logo = "_6-2";